<template>
  <div class="form">

    <b-row>
        <b-col sm="12">
            <h4 v-if="formTitle != ''" class="formTitle h4" v-html="formTitle"></h4>
            <p v-if="formSubtitle != ''" class="formSubtitle h5" v-html="formSubtitle"></p>

            <br>

            <div class="inputBlock">

                <svg class="formIcon" width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_contatti)">
                    <path d="M7.19995 89.8823C5.39995 89.8823 4 88.3821 4 86.6821C4 85.7821 4.3 84.9823 5 84.3823L15 74.4824C-1.3 55.6824 0.799976 27.2824 19.6 10.9824C38.4 -5.31762 66.8 -3.21801 83.1 15.582C99.4 34.382 97.3 62.782 78.5 79.082C70.3 86.182 59.9 90.082 49.1 90.082L7.19995 89.8823Z" fill="#39414E"/>
                    <path d="M33 40C35.8 40 38 42.2 38 45C38 47.8 35.8 50 33 50C30.2 50 28 47.8 28 45C28 42.2 30.3 40 33 40Z" fill="white"/>
                    <path d="M48.2002 40C51.0002 40 53.2002 42.2 53.2002 45C53.2002 47.8 51.0002 50 48.2002 50C45.4002 50 43.2002 47.8 43.2002 45C43.2002 42.2 45.4002 40 48.2002 40Z" fill="white"/>
                    <path d="M63.2998 40C66.0998 40 68.2998 42.2 68.2998 45C68.2998 47.8 66.0998 50 63.2998 50C60.4998 50 58.2998 47.8 58.2998 45C58.2998 42.2 60.4998 40 63.2998 40Z" fill="white"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_contatti" x="0" y="0" width="98.0822" height="98.082" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                    </filter>
                    </defs>
                </svg>

                <b-form-group :state="validateFields()">
                    <b-row>
                        <b-col sm="12" md="6">
                            <div class="customInputBlock">
                                <b-form-input ref="firstName" :required="true" v-model="firstName" type="text" placeholder="Nome *" data-e2e="salabamInput"/>
                                <span class="formError"></span>
                                <span class="formClear" @click="clearField('firstName')"></span>
                            </div>
                            <div class="customInputBlock">
                                <b-form-input ref="lastName" :required="true" v-model="lastName" type="text" placeholder="Cognome *" data-e2e="salabamInput"/>
                                <span class="formError"></span>
                                <span class="formClear" @click="clearField('lastName')"></span>
                            </div>
                            <div class="customInputBlock">
                                <b-form-input ref="company" :required="false" v-model="company" type="text" placeholder="Azienda" data-e2e="salabamInput"/>
                                <span class="formError"></span>
                                <span class="formClear" @click="clearField('company')"></span>
                            </div>
                            <div class="customInputBlock">
                                <b-form-input ref="email" :required="true" v-model="email" type="email" placeholder="Email *" data-e2e="salabamInput"/>
                                <span class="formError"></span>
                                <span class="formClear" @click="clearField('email')"></span>
                            </div>
                            <div class="customInputBlock">
                                <b-form-input ref="emailConfirm" :required="true" v-model="emailConfirm" type="email" placeholder="Ripeti l'email *" data-e2e="salabamInput"/>
                                <span class="formError"></span>
                                <span class="formClear" @click="clearField('email')"></span>
                            </div>
                        </b-col>

                        <b-col sm="12" md="6">
                            <div class="customInputBlock">
                                <b-form-textarea v-model="message" ref="message" name="message" id="message" placeholder="Vuoi darci altre informazioni? Scrivi qui" no-resize/>
                                <span class="formError"></span>
                                <span class="formClear" @click="clearField('textarea')"></span>
                            </div>
                            
                            <div class="customCheckboxBlock">
                                <b-form-checkbox v-model="privacy" ref="privacy" type="checkbox" name="privacy" :id="_uid+'-privacy'" />
                                <label :for="_uid+'-privacy'">
                                <a :href="privacyPolicyUrl" target="_blank">Ho letto ed accetto la Privacy Policy</a>
                                </label>
                                <br><br>
                            </div>

                            <div v-if="loading">
                                <Spinner />
                            </div>

                            <div v-else>
                                <div v-if="apiResponse !== ''">
                                <b-alert variant="info" show>
                                    {{apiResponse}}
                                </b-alert>
                                <br>
                                </div>
                                <div v-else>
                                    <b-button :disabled="!validateFields()" @click="submitForm">INVIA</b-button>
                                    <br/><br/>
                                    <span>oppure scrivici a business@vivamod.com o scopri altre modalità di contatto, <a :href="vivamodHost + 'informazioni#assistenza'" @click="clickOppureScrivici()">vai qui...</a></span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                </b-form-group>

            </div>

        </b-col>
    </b-row>

  </div>
</template>

<script>
  import Vue from 'vue'
  import Api from '../../api'
  import { VueReCaptcha } from 'vue-recaptcha-v3'
  import Spinner from '../atoms/spinner'

  export default {
    name: 'form-contatti',
    props:
    {
      formSubtitle:
      {
        type: String,
        default: '', // sottotitolo del form, renderizzato in alto se != ''
      },
      formTitle:
      {
        type: String,
        default: '', // titolo del form, renderizzato in alto se != ''
      },
      type:
      {
        type: String,
        default: 'form-contatti-business', // tipo form, usato per distinguere i form e per tracking
      },
      label:
      {
        type: String,
        default: '', // per distinguere lo stesso form messo in posti diversi, usato anche per tracking
      },
      recipient:
      {
        type: String,
        default: 'sales@salabam.com', // email destinatario
      }
    },
    components:
    {
      Spinner,
    },
    data()
    {
      return {
        uid: this._uid,
        loading: false,
        recaptchaEnabled: true,//Vue.prototype.$config.recaptcha.enabled,
        recaptchaToken: '',
        firstName: '',//(process.env.NODE_ENV != 'production')? 'Mario' : '',
        lastName: '',//(process.env.NODE_ENV != 'production')? 'Rossi' : '',
        company: '',//(process.env.NODE_ENV != 'production')? 'Vivamod' : '',
        email: '',//(process.env.NODE_ENV != 'production')? 'mario.rossi@vivamod.com' : '',
        emailConfirm: '',//(process.env.NODE_ENV != 'production')? 'mario.rossi@vivamod.com' : '',
        message: '',//(process.env.NODE_ENV != 'production')? 'Messaggio di prova da business.vivamod' : '',
        privacy: false,
        privacyPolicyUrl: process.env.VUE_APP_PRIVACY_POLICY_URL,//Vue.prototype.$config.site.urlPrivacy,
        apiResponse: '',
        vivamodHost: process.env.VUE_APP_VIVAMOD_HOST,
      }
    },
    mounted()
    {
      //if(Vue.prototype.$config.recaptcha.enabled)
      //{
        Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY })
      //}

    },
    methods:
    {
      async recaptcha() {
        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('login')
        this.recaptchaToken = token
        this.sendToApi()
      },
      clearField(ref)
      {
        this[ref] = ''
        this.$refs[ref].focus()
        this.validateFields()
      },       
      submitForm()
      {
        this.loading = true
        if(this.recaptchaEnabled)
        {
          this.recaptcha()
        }
        else
        {
          this.sendToApi()
        }
      },
      sendToApi()
      {
        let _this = this

        Api.formsSubmitter({
          recaptcha: _this.recaptchaToken,
          fields: {
            company: _this.company,
            firstName: _this.firstName,
            lastName: _this.lastName,
            email: _this.email,
            message: _this.message,
          },
          settings:
          {
            type: _this.type,
            label: _this.label,
            recipient: _this.recipient,
            formTitle: _this.formTitle,
          }
        })
        .then((data) => {
          
          _this.apiResponse = data.msg
          _this.loading = false

          if(this.$gtm) this.$gtm.trackEvent({
            event: 'customEvent',
            category: 'userBehaviour',
            action: 'formSubmit',
            label: _this.type,
            value: _this.label,
          })

        })
      },
      validateFields()
      {
        if(Object.keys(this.$refs).length == 0) return false

        return this.mixinValidateFields([
          {
            ref: this.$refs.firstName,
            type: 'firstName',
            value: this.firstName,
            optional: false,
          },
          {
            ref: this.$refs.lastName,
            type: 'lastName',
            value: this.lastName,
            optional: false,
          },
          {
            ref: this.$refs.company,
            type: 'textarea',
            value: this.company,
            optional: false,
          },
          {
            ref: this.$refs.email,
            type: 'email',
            value: this.email,
            optional: false,
          },
          {
            ref: this.$refs.emailConfirm,
            type: 'emailConfirm',
            value: (this.email == this.emailConfirm),
            optional: false,
          },
          {
            ref: this.$refs.message,
            type: 'textarea',
            value: this.message,
            optional: false,
          },
          {
            ref: this.$refs.privacy,
            type: 'checkbox',
            value: this.privacy,
            optional: false,
          }
        ])
      },
      clickOppureScrivici(){

        if(this.$gtm) this.$gtm.trackEvent({
          event: 'customEvent',
          category: 'userBehaviour',
          action: 'clickOppureScrivici',
          label: '',
          value: '',
        })

      }
    }
  }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';
    
    .form
    {
        position:relative;

        .inputBlock
        {
            position:relative;
            padding-right:60px;
        }
        .formIcon
        {
            position:absolute;
            top:0;
            right:0;
            width:90px;
            height:auto;
            z-index:1;
            transform:translateY(-50%) translateX(50%);
        }

        .customInputBlock input:focus ~ .formClear
        {
            top:18px;
            transform:none;
        }

        input,
        select,
        textarea,
        .custom-select,
        .dropdown,
        .form-control
        .input-group
        {
            border:1px solid #efefff !important;
            margin-bottom:1rem;
        }

        .formTitle
        {
        }

        .formSubtitle
        {
            color:$gray;
            font-weight: 400;
        }
    }
</style>